<template id="client-details">
  <div class="maxw">
    <h2>Detalls client</h2>
    <b-form>
      <b-tabs content-class="mt-3" fill>
        <b-tab title="Dades Comercials" active>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Client:"
                label-for="input-nombre"
              >
                {{ cliente.nombre }}
              </b-form-group>
            </b-col>
            <b-col> </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Adreça:"
                label-for="textarea-direccion"
              >
                {{ cliente.direccion }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="CP:"
                label-for="input-cp"
              >
                {{ cliente.cp }}
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Població:"
                label-for="input-poblacio"
              >
                {{ cliente.poblacion }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Provincia:"
                label-for="input-provincia"
              >
                {{ cliente.provincia }}
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Dades Fiscals">
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Client:"
                label-for="input-nombre"
              >
                {{ cliente.nombreFiscal }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="NIF:"
                label-for="input-nif"
              >
                {{ cliente.nif }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Tipus IVA::"
                label-for="input-iva"
              >
                {{ cliente.tipoIVA }} %
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Subtitulo:"
                label-for="input-cp"
              >
                {{ cliente.subtitulo }}
              </b-form-group>
            </b-col>

            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Adreça:"
                label-for="textarea-direccion"
              >
                {{ cliente.direccionFiscal }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="CP:"
                label-for="input-cp"
              >
                {{ cliente.cpFiscal }}
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="Numero de Orden:" label-for="input-orden">
                {{ cliente.ordenFiscal }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="Orden Concepto:" label-for="input-ordenconcepto">
                {{ cliente.ordenConceptoFiscal }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group label-class="font-weight-bold" label="Orden Concepto:" label-for="input-ordenconcepto">
                {{ tiposVencimiento[cliente.tipoVencimiento].text }}
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Població:"
                label-for="input-poblacio"
              >
                {{ cliente.poblacionFiscal }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Provincia:"
                label-for="input-provincia"
              >
                {{ cliente.provinciaFiscal }}
              </b-form-group>
            </b-col>
            <b-col></b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="SWIFT:"
                label-for="input-poblacio"
              >
                {{ cliente.swift }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Cuenta Bancaria:"
                label-for="input-provincia"
              >
                {{ cliente.iban }}
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Gestión por Adeudo:"
                label-for="input-provincia"
              >
                {{ cliente.isAdeudo }}
              </b-form-group>
            </b-col>

          </b-row>
          <b-row>
            <b-col>
              <b-form-group
                label-class="font-weight-bold"
                label="Personas de Contacto:"
              >
                {{ cliente.personasContacto }}
              </b-form-group>
            </b-col>
          </b-row>
        </b-tab>
      </b-tabs>
      <b-row>
        <h3>Productes</h3>
      </b-row>
      <b-table
        striped
        hover
        :items="cliente.clienteProductos"
        :fields="Productfields"
      ></b-table>
      <b-row>
        <b-col cols="6"></b-col>
        <b-col class="col text-right">
          <b-button
            class="mr-2"
            variant="outline-success"
            @click="
              $router.push({ name: 'ClientEdit', params: { cliente: cliente } })
            "
            >Editar</b-button
          >
          <b-button
            class="mr-2"
            variant="outline-danger"
            @click="
              $router.push({
                name: 'ClientDelete',
                params: { cliente: cliente },
              })
            "
            >Esborrar</b-button
          >
          <b-button class="mr-2" variant="outline-primary"
            ><router-link :to="{ name: 'Clients' }"
              >Cancel</router-link
            ></b-button
          >
        </b-col>
      </b-row>
      <b-form-input
        :hidden="true"
        type="text"
        v-model="cliente.identifier"
      ></b-form-input>
    </b-form>
  </div>
</template>

<script>
export default {
  props: {
    cliente: {
      identifier: null,
      nombre: null,
      nif: null,
      cp: null,
      poblacion: null,
      provincia: null,
      direccion: null,
      nombreFiscal: null,
      subtitulo: null,
      cpFiscal: null,
      poblacionFiscal: null,
      provinciaFiscal: null,
      ordenFiscal: null,
      ordenConceptoFiscal: null,
      swift: null,
      iban: null,
      isAdeudo: null,
      personasContacto: null,
      tipoVencimiento:null,
    }
  },
  data () {
    return {
      tiposVencimiento: [
        { value: '0', text: 'Contado' },
        { value: '1', text: '30 días' },
        { value: '2', text: '60 días' },
        { value: '3', text: '30 días, fin mes' },
      ],
      Productfields: [
        {
          key: 'productoTitulo',
          label: 'Titulo',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'productoPrecio',
          label: 'Precio',
          sortable: false
        },
        {
          key: 'isRecurrente',
          label: 'Recurrent',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        },
        {
          key: 'isActive',
          label: 'Está Activo',
          formatter: (value, key, item) => {
            return value ? 'Sí' : 'No'
          },
          sortable: true,
          sortByFormatted: true,
          filterByFormatted: true
        }
      ]
    }
  }
}
</script>

<style scoped>
  .maxw {
    width: 80%;
    margin: 40px auto;
  }
</style>
